'use client'

import { MobileTabs } from '@/components/organisms/MobileTabs/MobileTabs'
import React, { ReactNode } from 'react'
import styles from './MobilePageTemplate.module.scss'

type Props = {
  children: ReactNode;
  navbar?: ReactNode;
  withoutGradient?: boolean;
  withTabs?: boolean;
}

export function MobilePageTemplate({ children, navbar, withTabs = true, withoutGradient = false }: Props) {
  return (
    <section className={styles.root}>
      {!withoutGradient && <img src="/gradient.png" className={styles.radialBg} alt="Gradient" />}
      {navbar && navbar}
      {children}
      {withTabs && <MobileTabs />}
    </section>
  )
}
